"use strict";
/* eslint-disable sonarjs/cognitive-complexity */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const moment_1 = __importDefault(require("moment"));
const react_dates_1 = require("react-dates");
const HeaderMobile_1 = __importDefault(require("./HeaderMobile"));
const className_1 = require("../../utils/className");
const Button_1 = require("../Button");
const NewDatePickerWrapper = ({ showInputs = true, startDate, endDate, onDatesChange, onToggle, isOpen = false, isSingleDate = false, disabled = false, singleDateTitleHeader = 'Data da viagem', minimumNights = 1, displayFormat = 'ddd, DD MMM', datesListHighlight = [], startDatePlaceholderText = '', endDatePlaceholderText = '', statusAnimation = 'paused', forceFocus, numberOfVerticalMonths, isOutsideRange, renderMonthElement, renderDayContents, }) => {
    const START_DATE = 'startDate';
    const END_DATE = 'endDate';
    const [focusedInput, setFocusedInput] = react_1.useState(START_DATE);
    const containerRef = react_1.useRef(null);
    const mobileInputRef = react_1.useRef(null);
    const [isTopScroll, setOnScroll] = react_1.useState(true);
    const startDateString = startDate && startDate.format('YYYY-MM-DD');
    const endDateString = endDate && endDate.format('YYYY-MM-DD');
    const handleOnFocusChange = (inputChange) => {
        if (isSingleDate) {
            setFocusedInput(START_DATE);
            return;
        }
        setFocusedInput(!inputChange ? START_DATE : inputChange);
    };
    const onScroll = (e) => {
        const target = e.target;
        setOnScroll(false);
        if (target.scrollTop === 0)
            setOnScroll(true);
    };
    const closeCalendarMobile = () => {
        if (onToggle) {
            setFocusedInput(null);
            return onToggle(false);
        }
        return undefined;
    };
    const handleSubmit = () => {
        closeCalendarMobile();
    };
    const setValue = () => {
        let value = '';
        if (startDateString && endDateString && !isOpen) {
            value = `${moment_1.default(startDateString || '').format(displayFormat)} - ${moment_1.default(endDateString).format(displayFormat)}`;
        }
        if (startDateString && isSingleDate && !isOpen) {
            value = `${moment_1.default(startDateString || '').format(displayFormat)}`;
        }
        return value;
    };
    react_1.useEffect(() => {
        if (!datesListHighlight || datesListHighlight.length === 0)
            return;
        if (containerRef && containerRef.current) {
            const calendars = containerRef.current.getElementsByClassName('CalendarMonth');
            if (!calendars)
                return;
            if (!calendars.forEach) {
                calendars.forEach = Array.prototype.forEach;
            }
            calendars.forEach((htmlCalendar, idx) => {
                const monthIcon = htmlCalendar.getElementsByClassName('smls-calendar-month-icon');
                if (monthIcon && monthIcon.length)
                    return;
                const monthTextContent = htmlCalendar.getElementsByTagName('strong');
                if (!monthTextContent)
                    return;
                const monthText = monthTextContent[0].textContent || monthTextContent[0].innerText;
                const idxMonth = moment_1.default.months().indexOf(monthText.toLocaleLowerCase());
                const idxYear = Math.abs(Math.floor(idx / 12));
                const momentDate = moment_1.default.utc(new Date(`${moment_1.default().get('year') + idxYear}-${idxMonth + 1 < 10 ? '0' : ''}${idxMonth + 1}-01`));
                const highlightDays = datesListHighlight.filter((holyday) => holyday.date.get('month') === momentDate.month() &&
                    holyday.date.year() === momentDate.year());
                if (!highlightDays || !highlightDays.length)
                    return;
                const infoPanel = document.createElement('ul', {});
                infoPanel.setAttribute('class', 'smls-calendar-month-icon');
                highlightDays.forEach((day) => {
                    const li = document.createElement('li', {});
                    const span = document.createElement('span', {});
                    span.innerText = `${day.date.date().toString()} - ${day.description}`;
                    li.appendChild(span);
                    infoPanel.appendChild(li);
                });
                htmlCalendar.appendChild(infoPanel);
            });
        }
    }, [containerRef.current]);
    react_1.useEffect(() => {
        if (forceFocus && mobileInputRef.current) {
            mobileInputRef.current.focus();
        }
    }, [forceFocus, mobileInputRef]);
    return (react_1.default.createElement("div", { ref: containerRef, onScroll: onScroll, style: {
            height: '100%',
            width: '100%',
            position: isOpen ? 'absolute' : 'initial',
            zIndex: 1029,
        } },
        showInputs && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: className_1.mapToCssModules([
                    'smls-calendar-mobile-input-container',
                    !isTopScroll && isOpen ? 'on-scroll-shadow' : '',
                ]) },
                react_1.default.createElement("div", { className: "smls-calendar-single-date-header-input", style: {
                        display: isSingleDate && isOpen ? 'flex' : 'none',
                    } }, singleDateTitleHeader),
                react_1.default.createElement("button", { disabled: disabled, className: className_1.mapToCssModules([
                        'smls-calendar-header-input',
                        disabled ? 'disabled' : '',
                    ]), style: {
                        display: isSingleDate && isOpen ? 'none' : '',
                        border: '1px solid red !important',
                    }, type: "button", onFocus: () => {
                        if (disabled)
                            return undefined;
                        if (onToggle)
                            return onToggle(true);
                        return undefined;
                    } },
                    react_1.default.createElement("div", { style: { textAlign: 'left' }, className: forceFocus && !isOpen ? 'selected' : '' },
                        react_1.default.createElement("button", { type: "button", className: "smls-calendar-input-button" },
                            react_1.default.createElement("i", { className: "material-icons notranslate", tabIndex: -1 }, "\uE878")),
                        react_1.default.createElement("input", { id: "date-mobile", ref: mobileInputRef, type: "text", name: "startDate", className: "singleDate", value: setValue(), onFocus: () => {
                                setFocusedInput(START_DATE);
                                return undefined;
                            }, tabIndex: -1, placeholder: startDatePlaceholderText, readOnly: true }),
                        react_1.default.createElement("input", { id: "start-date-mobile", type: "text", style: { display: isSingleDate && isOpen ? 'none' : '' }, className: focusedInput === START_DATE ? 'selected' : '', name: "startDate", value: startDateString
                                ? moment_1.default(startDateString || '').format(displayFormat)
                                : '', onFocus: () => {
                                setFocusedInput(START_DATE);
                                if (onToggle)
                                    return onToggle(true);
                                return undefined;
                            }, tabIndex: -1, placeholder: startDatePlaceholderText, readOnly: true }),
                        react_1.default.createElement("input", { id: "end-date-mobile", type: "text", style: {
                                display: isSingleDate && isOpen ? 'none' : '',
                            }, className: focusedInput === END_DATE ? 'selected' : '', name: "endDate", value: endDateString
                                ? moment_1.default(endDateString).format(displayFormat)
                                : '', tabIndex: -1, onFocus: () => {
                                if (onToggle)
                                    return onToggle(true);
                                return undefined;
                            }, placeholder: endDatePlaceholderText, readOnly: true }))),
                react_1.default.createElement("button", { type: "button", className: "smls-calendar-header-button", onClick: closeCalendarMobile },
                    react_1.default.createElement("i", { "data-testid": "close-modal-mobile", className: "material-icons notranslate", "aria-label": "Close", tabIndex: -1 }, "\uE5CD")),
                react_1.default.createElement("div", { className: "action-panel", style: {
                        display: (isOpen && endDateString && statusAnimation === 'paused') ||
                            (isOpen &&
                                isSingleDate &&
                                startDateString &&
                                statusAnimation === 'paused')
                            ? 'block'
                            : 'none',
                    } },
                    react_1.default.createElement(Button_1.SmlsButton, { text: "Confirmar", className: "button-confirm", onClick: handleSubmit }))))),
        react_1.default.createElement(react_dates_1.DayPickerRangeController, { renderMonthElement: (momentMonth) => {
                if (renderMonthElement)
                    return renderMonthElement(momentMonth);
                return react_1.default.createElement(HeaderMobile_1.default, { currentMoment: momentMonth.month });
            }, renderDayContents: renderDayContents, minimumNights: isSingleDate ? 0 : minimumNights, isDayBlocked: () => false, isOutsideRange: isOutsideRange ||
                ((day) => !react_dates_1.isInclusivelyAfterDay(day, moment_1.default()) ||
                    !react_dates_1.isInclusivelyBeforeDay(day, moment_1.default().add(330, 'days'))), isDayHighlighted: (day1) => datesListHighlight.some((day2) => react_dates_1.isSameDay(day1, day2.date)), enableOutsideDays: false, daysViolatingMinNightsCanBeClicked: false, orientation: "verticalScrollable", verticalHeight: 800, withPortal: false, initialVisibleMonth: () => moment_1.default(), numberOfMonths: numberOfVerticalMonths, isRTL: false, onDatesChange: onDatesChange, onFocusChange: handleOnFocusChange, focusedInput: focusedInput, startDate: startDate || null, endDate: endDate || null, calendarInfoPosition: "bottom" })));
};
exports.default = NewDatePickerWrapper;
//# sourceMappingURL=DatePickerWrapper.js.map